import React from 'react';
import { CircularProgress } from '@mui/material';
import { PieChart, Pie, Cell, Text, Tooltip, ResponsiveContainer } from 'recharts';

const colors: string[] = [
    '#F6B667', '#80E7DA', '#FF8E84', '#FF4C61', '#FFA4C4',
    '#46C173', '#4E95D2', '#A66F37', '#A383FF', '#FFAA7D',
    '#6CC6A1', '#FFBD44', '#FF57BB', '#3DB9FF', '#FF7676',
    '#B877FF', '#FFD076', '#72EAD4', '#6B8EF1', '#FF98A1',
    '#FFA867', '#8CFF95', '#FFEB67', '#FF6E6E', '#B2FF6E',
    '#6EBFFF', '#FF94D6', '#FF8C4C', '#95FF8C', '#FF4C88'
];
interface IObj {
    label: string;
    count: number;
}
interface IProps {
    data: IObj[];
    totalCount: number;
    loader: boolean;
    circleTitle: string;
    heading: string;
};

const PieChartGraph: React.FC<IProps> = ({
    data = [], totalCount = 0, loader = false, circleTitle = "", heading = ""
}) => {
    // Custom label rendering function
    const renderCustomLabel = ({
        cx,
        cy,
        midAngle,
        innerRadius,
        outerRadius,
        value,
    }: {
        cx: number;
        cy: number;
        midAngle: number;
        innerRadius: number;
        outerRadius: number;
        value: number;
    }) => {
        const RADIAN = Math.PI / 180;
        const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
        const x = cx + radius * Math.cos(-midAngle * RADIAN);
        const y = cy + radius * Math.sin(-midAngle * RADIAN);

        return (
            <Text x={x} y={y} fill="white" verticalAnchor="middle" textAnchor='middle' dominantBaseline="middle">
                {value}
            </Text>
        );
    };

    return (
        <div style={{ height: '100%' }}>
            <h2 className="font-Poppins-SemiBold text-[#232323] font-size-20px mb-2">{heading}</h2>
            <div className='user-graph-inner h-[90%]'>
                {loader &&
                    <div className="text-center">
                        <CircularProgress size={20} style={{ color: "#004540" }} />
                    </div>
                }
                <div className='Biomarkers-graph'>
                    <div className='bio-graph-bio-legend-main'>
                        {data.filter(v => v.count > 0).map((v: IObj, i: number) => (
                            <div
                                className='bio-graph-bio-legend'
                                key={`legend-${i}`}>
                                <div
                                    className='bio-graph-bio-color'
                                    style={{
                                        backgroundColor: colors[i],
                                        borderRadius: '50%',
                                    }}
                                ></div>
                                <span className='font-size-16px capitalize'>{v?.label || ""}</span>
                            </div>
                        ))}
                    </div>
                    <div className='relative h-[100%] w-[100%]'>
                        <div className='relative pie-chart-container w-[100%]'>
                            <ResponsiveContainer>
                                <PieChart >
                                    <Pie
                                        data={data.filter(v => v.count > 0)}
                                        dataKey="count"
                                        nameKey="name"
                                        cx="50%"
                                        cy="50%"
                                        outerRadius={120}
                                        innerRadius={70}
                                        startAngle={200}
                                        endAngle={1000}
                                        paddingAngle={0.5}
                                        label={renderCustomLabel}
                                        labelLine={false}
                                    >
                                        {data.filter(v => v.count > 0).map((_: any, i: number) => (
                                            <Cell key={`cell-${i}`} fill={colors[i]} />
                                        ))}
                                    </Pie>
                                    {/* <Tooltip position={{ x: -30, y: -10 }} /> */}
                                </PieChart>
                            </ResponsiveContainer>
                        </div>
                        <div className='bio-graph-bio-count'>
                            <span>{totalCount}</span>
                            <p>{circleTitle}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PieChartGraph;